module.exports = __webpack_public_path__ + "img/container-port.38f55a51.svg";